import { browser } from '$app/environment';
import { getEventAlerts, getPriceAlerts } from '$utils/alerts.js';
import { raceFilters } from '$utils/filters.js';
import { getRaces } from '$utils/race.js';

import { get, writable } from 'svelte/store';

export const load = async ({ fetch, depends, parent, params: { date } }) => {
  depends('betwatch:races');
  const { session, guestId } = await parent();

  const today = new Date();
  const future = new Date();
  today.setDate(today.getDate() - 1);
  future.setDate(future.getDate() + 10);
  let todayString = new Date(
    today.getTime() - today.getTimezoneOffset() * 60000
  )
    .toISOString()
    .split('T')[0];
  let futureString = new Date(
    future.getTime() - future.getTimezoneOffset() * 60000
  )
    .toISOString()
    .split('T')[0];

  const activeFilters = get(raceFilters);
  if (browser && activeFilters.dates.length > 0) {
    //   get date in YYYY-MM-DD format
    todayString = activeFilters.dates[0];
    futureString = activeFilters.dates[0];
  }

  //   we also need to make sure that the current date is included in the list of dates
  // we can get this from the url params

  const priceAlerts = writable(
    await getPriceAlerts({
      accessToken: session?.access_token,
      fetch
    })
  );

  const eventAlerts = writable(
    await getEventAlerts({
      accessToken: session?.access_token,
      fetch
    })
  );

  const races = writable(
    await getRaces(
      fetch,
      { accessToken: session?.access_token, guestId },
      todayString,
      futureString,
      {
        andDates: date ? [date] : undefined
      }
    )
  );

  return {
    races,
    dateFrom: todayString,
    dateTo: futureString,
    priceAlerts,
    eventAlerts
  };
};
